import api from "../api";

export interface NewsletterResponse {
  message: string;
  success: boolean;
}

export interface NewsletterSubscription {
  email: string;
  name?: string;
}

export async function subscribeToNewsletter(
  data: NewsletterSubscription,
): Promise<NewsletterResponse> {
  const response = await api.post<NewsletterResponse>(
    "/newsletter/subscribe",
    data,
  );
  return response.data;
}
